<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-10 17:30:51
 * @LastEditors: 小白
 * @LastEditTime: 2024-09-04 11:15:29
 * @FilePath: \huizhou_website\src\components\footer-index.vue
-->
<template>
  <div>
    <div class="link_box">
      <div
        class="footer_right"
        style="justify-content: space-between;align-items: center;"
        :style="isPhone == 'false'?{display: 'flex'}:{display: 'inline-block',fontSize:'14px'}">
        <div
          v-for="
        (item,index) in linkDatas"
          :key="index"
          :style="isPhone =='false'?{width:'100%'}:{width:'auto',display:'inline-block',marginRight:'15px'}"
          style="text-align: center;">
          <a :href="item.url"
            style="color: #ffffff;"
            target="_blank">{{ item.name }}</a>
        </div>
      </div>
    </div>
    <div class="footer_box">
      <div
        class="content_1260">
        <div class="el-row lefts">
          <div
            class="el-col el-col-24 el-col-sm-24 el-col-md-24 el-col-lg-24" style="text-align:left">
            <div
              class="footer_text"
              :style="isPhone == 'false'?{fontSize: '16px'}:{fontSize: '14px',textAlign:'left',paddingLeft:'10px'}">
              <span
                class="mr-30"
                :style="isPhone == 'false'?{display: 'inline-block'}:{display: 'block'}">
                <i
                  class="el-icon-phone mr-10"></i>
                <span>联系电话：0752-7218399</span>
              </span>
              <span
                class="mr-30"
                :style="isPhone == 'false'?{display: 'inline-block'}:{display: 'block'}">
                <i
                  class="el-icon-message mr-10"></i>
                <span>电子邮箱：{{ contact.email }}</span>
              </span>
              <span
                class="mr-30"
                :style="isPhone == 'false'?{display: 'inline-block'}:{display: 'block'}">
                <i
                  class="el-icon-location-information mr-10"></i>
                <span>公司地址：{{ contact.address }}</span>
              </span>
            </div>
            <div class="rights" v-if="isPhone == 'true'" style="text-align:left;margin-top:20px;font-size:14px;margin-left:10px;">
          <div style="margin-bottom: 10px;">保障中小企业款项和农民工工资支付投诉热线:</div>
           <div  style="margin-bottom: 5px;font-weight:bold">0752-2697659</div>
        </div>
            <div class="mt-20"
              :style="isPhone == 'false'?{fontSize: '16px'}:{fontSize: '14px',marginLeft:'10px'}">
              <span
                :style="isPhone == 'false'?{display: 'inline-block'}:{display: 'block'}">
                CopyRight ©
                2024
                惠州市城市建设投资集团有限公司
              </span>
              <span
                :style="isPhone == 'false'?{display: 'inline-block'}:{display: 'block'}">
                All Right
                Reserved. |
                <span
                  @click="openPage()">粤ICP备18003786号-1
                </span></span>
            </div>
          </div>
        </div>
        <div class="rights" v-if="isPhone == 'false'" style="text-align:center">
          <div style="margin-bottom: 5px;">保障中小企业款项和</div>
           <div  style="margin-bottom: 10px;">农民工工资支付投诉热线</div>
           <div  style="margin-bottom: 5px;font-weight:bold">0752-7218366</div>
        </div>
      </div>
       
    </div>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    linkDatas: {
      type: Array,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      contact: {},
      isPhone: 'false'
    }
  },
  mounted() {
    if (window.localStorage.getItem('isPhone')) this.isPhone = window.localStorage.getItem('isPhone')
    else this.isPhone = 'false'
    this.getContact()
  },
  methods: {
    getContact() {
      axios.post('/home/contact/us', {}).then(res => {
        this.contact = res.data.data.contactUs
      })
    },
    openPage() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style>
.footer_box {
  text-align: left;
  padding: 30px 0;
  border-bottom: 1px solid #d9d9d9;
  /* background: rgba(25, 47, 89,.5); */
  /* color: #ffffff; */
}
.link_box {
  padding: 10px;
  background: rgba(25, 47, 89, 1);
  color: #ffffff;
}
.footer_right {
  max-width: 1260px;
  margin: 0 auto;
  width: 100%;
  font-size: 14px;
  font-weight: bold;
}
.footer_right span {
  border-right: 1px solid #999999;
  padding: 0 5px;
}
.footer_right span:last-child {
  border-right: none;
}
.content_1200.phone {
  display: block;
}
.footer_box.phone {
  padding: 20px;
}
.content_1200.phone .footer_right {
  margin-top: 10px;
}
.content_1260{
  max-width: 1260px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
